import {EChannelType, TChannelType} from 'src/constants';

enum EMigrationStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

type TSubjectMigration = {
  id: number;
  requestId: number;
  subjectId: number;
  profileId?: number;
  licenseId?: number;
  availableTariffId: number;
  newSubjectId?: number;
  status: EMigrationStatus;
  errorMessage?: string;
};

type TSubjectMigrationRequest = {
  id: number;
  sourceTenantId: number;
  targetTenantId: number;
  channelType: EChannelType;
  status: EMigrationStatus;
  blockOldLicense: boolean;
  migrateOperatorTemplates: boolean;
  migrateJivoIntegration?: boolean;
  migrateCallbackIntegration?: boolean;
  migrateHpxIntegration?: boolean;
  createdByUserId?: number;
  scheduledAt: string;
  createdAt?: string;
  updatedAt?: string;
  migrations: TSubjectMigration[];
};

type TCreateMigrationSubject = {
  subjectId: number;
  licenseId?: number;
  availableTariffId?: number;
};

type TCreateMigrationPayload = {
  sourceTenantId: number;
  targetTenantId: number;
  channelType: EChannelType;
  subjects: TCreateMigrationSubject[];
  blockOldLicense: boolean;
  migrateOperatorTemplates: boolean;
  migrateJivoIntegration: boolean;
  migrateCallbackIntegration: boolean;
  migrateHpxIntegration: boolean;
  scheduledAt: string;
};

type TMigrationFormData = {
  sourceTenantId: string;
  channelType: EChannelType | null;
  subjectIds: number[];
  targetTenantId: string;
  availableTariffId: string;
  scheduledDate?: Date;
  scheduledTime: string;
  blockOldLicense: boolean;
  migrateOperatorTemplates: boolean;
  migrateJivoIntegration: boolean;
  migrateCallbackIntegration: boolean;
  migrateHpxIntegration: boolean;
};

type TSubject = {
  id: number;
  name: string;
  channelType?: EChannelType;
  subject: string;
};

type TLicense = {
  id: number;
  name?: string;
  status?: string;
  channelType?: EChannelType;
};

type TAvailableTariff = {
  id: number;
  name: string;
  channelType?: EChannelType;
  active?: boolean;
};

const MIGRATION_CHANNEL_TYPES = [EChannelType.WHATSAPP] as const;

type TPrismMigrationPayload = {
  pulseId: number;
  inn: string;
  subject: string;
  startDate: string;
  endDate?: string;
  pulseAccount: string;
  billing: boolean;
  channelType: TChannelType;
};

export {
  EMigrationStatus,
  MIGRATION_CHANNEL_TYPES,
  TSubjectMigration,
  TSubjectMigrationRequest,
  TCreateMigrationPayload,
  TMigrationFormData,
  TSubject,
  TLicense,
  TAvailableTariff,
  TPrismMigrationPayload,
};
